import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { Attending } from '../../model/attending';
import { AuthenticationService } from '../../../shared/service/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FileService } from '../../../shared/service/file.service';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.css']
})
export class ValidationComponent implements OnInit, AfterViewChecked {
  private _attending: Attending;
  VALIDATION = 'VALIDATION';
  authenticatedUser: any;
  files = new Array();

  @Input() editable: boolean;
  @Output() txOnSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() txOnCancel: EventEmitter<any> = new EventEmitter<any>();

  get attending() {
    return this._attending;
  }

  @Input()
  set attending(attending) {
    this._attending = attending;
    this.setUpObservers();
    this.showStep();
  }

  constructor(private _authService: AuthenticationService,
              private _sanitizer: DomSanitizer,
              private _fileService: FileService,
              private _toastService: ToastService) {
    this.authenticatedUser = this._authService.getUserFromLocalStorage();
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  save() {
    const files = this.assembleCorrectFilesList();
    if (files.length > 0) {
      /**
       * On save will be called after file upload success
       * See subscribment: setUpObservers()
       */
      this.showMessage('Enviando arquivos.');
      this._fileService.saveValidationFiles(files);
    } else {
      this.txOnSave.emit({ attending: this.attending });
    }
  }

  cancel() {
    this.txOnCancel.emit();
  }

  fileChange(event) {
    const tempFiles = event.target.files;
    for (let i = 0; i < tempFiles.length; i++) {
      const reader = new FileReader();
      reader.onload = (otherEvent: any) => {
        this.files.push({id: i, url: this.sanitizeUrl(otherEvent.target.result), file: event.target.files[i]});
      };
      reader.readAsDataURL(event.target.files[i]);
    }
  }

  sanitizeUrl(url) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  validationHasFiles() {
    try {
      return this.attending.validation.files.length > 0;
    } catch (e) {
      return false;
    }
  }

  changeItemValue(item: string) {
    this.attending.validation[item] = !this.attending.validation[item];
  }

  removeFileFromValidation(file) {
    const fileToDelete = this.attending.validation.files.find(f => f.id === file.id);
    fileToDelete.delete = true;
  }

  removeFileFromInMemoryList(files, file) {
    const fileIndex = files.indexOf(file);
    files.splice(fileIndex, 1);
  }

  canEdit() {
    return (this.attending.validation.canEdit || this.attending.validation.canEdit === undefined) && this.editable;
  }

  canView() {
    return this.attending.validation.canView && !this.canEdit();
  }

  private showStep() {
    if (this.attending.orderedSteps  && this.attending.currentStep === this.VALIDATION) {
      this.setIsVisible();
      this.setIsEditable();
    }
  }

  private setIsVisible() {
    if (this.attending.orderedSteps.includes(this.VALIDATION)
        && this.authenticatedUser.stepViews.find(view => view.stepViewType === this.VALIDATION)) {
      this.attending.validation.canView = true;
    } else {
      this.attending.dispatch.canView = false;
    }
  }

  private setIsEditable() {
    if (this.authenticatedUser.stepKeys.find(view => view.stepType === this.VALIDATION)) {
      this.attending.validation.canEdit = true;
    } else {
      this.attending.validation.canEdit = false;
    }
  }

  private assembleCorrectFilesList() {
    const newFiles = new Array();
    this.files.forEach(file => {
      newFiles.push(file.file);
    });
    return newFiles;
  }

  private setUpObservers() {
    if (this.canEdit()) {
      this._fileService.save$
      .subscribe(files => {
        let attending = { ...this.attending };
        this.files = [];
        let validationFiles = attending.validation.files || [];
        attending.validation.files = [ ...files, ...validationFiles ];
        this.showMessage('Arquivos enviados.');
        this.txOnSave.emit({ attending });
      });

    this._fileService.error$
      .subscribe((error) => {
        this.files = [];
        this.showMessage('Erro ao enviar os arquivos');
      });
    }
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/validation/validation.component.ts